<style lang="scss" scoped>
@import "core";

// $my-font:
//   'Hiragino Kaku Gothic ProN',
//   'ヒラギノ角ゴ ProN W3',
//   Meiryo,
//   メイリオ,
//   Osaka,
//   'MS PGothic',
//   arial,
//   helvetica,
//   sans-serif;

.my-rank-text {
  // font-family: $my-font;

  &--asterisk {}
}
</style>



<template>
  <span>{{displayValue}}</span>
</template>



<script>
export default {
  props: {
    value: {
      type: String,
      required: true,
    },
  },

  computed: {
    isAsterisk() { return this.value === '*' },
    classes() {
      return {
        'my-rank-text': true,
        'my-rank-text--asterisk': this.isAsterisk,
      }
    },
    displayValue() {
      return this.isAsterisk ? '＊' : this.value;
    },
  },
}
</script>



// WEBPACK FOOTER //
// RankText.vue?98043c6a